import { memo, useCallback } from 'react';

import { BasicTooltip, Flex, Input, Label, Text, TextField } from '@/components/core';
import { useTriggerStore } from '@/store';
import { toString } from '@/utils';

export type HttpHmacSecretProps = {
  placeholder?: string;
  isDisabled?: boolean;
};

const IHttpHmacSecret = ({ placeholder, isDisabled }: HttpHmacSecretProps) => {
  const action = useTriggerStore((state) => state.action);
  const updateAction = useTriggerStore((state) => state.updateAction);

  const updateHmacSecret = useCallback(
    (hmacSecret: string) => {
      updateAction({ config: hmacSecret ? { ...action.config, hmacSecret } : { ...action.config, hmacSecret: null } });
    },
    [action.config, updateAction]
  );

  return (
    <Flex col className="gap-md">
      <TextField onChange={updateHmacSecret} value={toString(action.config?.hmacSecret)} isDisabled={isDisabled}>
        <div className="gap-sm flex items-center">
          <Label>HMAC Secret</Label>
          <BasicTooltip>
            <Text slot="description">
              The hmac secret used to sign the request. See{' '}
              <a
                className="underline"
                href="https://docs.cradl.ai/integrations/webhook#verifying-signatures"
                target="_blank"
              >
                verifying signatures documentation
              </a>{' '}
              for more details and examples.
            </Text>
          </BasicTooltip>
        </div>
        <Input placeholder={placeholder} />
      </TextField>
    </Flex>
  );
};

export const HttpHmacSecret = memo(IHttpHmacSecret) as typeof IHttpHmacSecret;
